package com.yet.tetris.domain.model.progression

enum class ProgressAchievementId {
    FIRST_GAME,
    SCORE_5000,
    SCORE_20000,
    FIRST_TETRIS,
    FIRST_TSPIN,
    COMBO_5,
    PERFECT_CLEAR,
    TEN_GAMES,
}
